import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { northProvidenceConfig } from "./data";

export default function NorthProvidencePage() {
  return <CityPageTemplate config={northProvidenceConfig} />;
}